<template>
	<div class="legends-panel">
		<div>{{ $t('Luminaire') }} <img src="/map/blue_box.jpg" /></div>
		<div>{{ $t('Luminaire with movement sensor') }} <img src="/map/bluered_box.jpg" /></div>
		<div>{{ $t('Luminaire with lightlevel sensor') }} <img src="/map/blueyellow_box.jpg" /></div>
		<div>{{ $t('Luminaire with both sensors') }} <img src="/map/blueredyellow_box.jpg" /></div>
		<div>{{ $t('Movement sensor') }} <img src="/map/red_box.jpg" /></div>
		<div>{{ $t('Lightlevel sensor') }} <img src="/map/yellow_box.jpg" /></div>
		<div>{{ $t('Movement and lightlevel sensor') }} <img src="/map/redyellow_box.jpg" /></div>
		<div>{{ $t('Gateways') }} <img src="/map/blue_triangle.png" /></div>
		<div>{{ $t('All other sensors') }} <img src="/map/purple_box.jpg" /></div>
		<div>{{ $t('Selected device') }} <img src="/map/green_box.jpg" /></div>
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'IconsLegend',
});
</script>

<style lang="scss" scoped>
.legends-panel {
	background: rgba(240, 255, 255);
	color: rgba(255, 50, 50);
	border-width: thick;
	border-style: solid;
	border-color: rgba(0, 230, 100);
	font-size: 16px;
	div {
		margin-left: 10px;
		margin-right: 10px;
	}
	img {
		width: 16px;
	}
}
</style>
